import { Box, Skeleton, Typography, pn } from '@compass/core';
import { Column } from 'devextreme-react/data-grid';
import { DevExpressReport } from 'components';
import { DashboardCard } from '../components/DashboardCard';
import { useGPAData } from '../contexts';
import { GPADistributionDto } from 'generated/openApi';
import { GPAFilterControls } from './GPAFilterControls';

export const GPATableCard = () => {
    const { data, loading, error, filter, termTypes, schools, gradeLevels } = useGPAData();

    const handleExport = () => {
        if (data.length === 0) return;

        const yearsLabel = filter.schoolYears.length
            ? filter.schoolYears.map(year => `${year}-${year + 1}`).join(', ')
            : 'Current School Year';
        const termLabel = filter.termTypeId
            ? `${termTypes.find(termType => termType.id === filter.termTypeId)?.name || 'Term'} ${filter.termNumber || 1}`
            : 'Whole Year';
        const schoolLabel = filter.schoolId
            ? schools.find(school => school.id === filter.schoolId)?.name || 'Selected School'
            : 'All Schools';
        const gradeLevelLabel = filter.gradeLevelId
            ? gradeLevels.find(gradeLevel => gradeLevel.id === filter.gradeLevelId)?.name || 'Selected Grade Level'
            : 'All Grade Levels';
        const csvValue = (value: string | number) => `"${String(value).replace(/"/g, '""')}"`;
        const rows = data.map(item => [
            `${item.year}-${item.year + 1}`,
            item.schoolName,
            item.gradeLevelName,
            item.gpaName,
            item.studentCount,
            `${item.percentage}%`,
        ].map(csvValue).join(','));
        const csvContent = [
            '# GPA Distribution',
            `# Years: ${yearsLabel}`,
            `# Term: ${termLabel}`,
            `# School: ${schoolLabel}`,
            `# Grade Level: ${gradeLevelLabel}`,
            `# Exported: ${new Date().toLocaleDateString()}`,
            '',
            'School Year,School,Grade Level,GPA Range,Students,Percentage',
            ...rows,
        ].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `GPA_${filter.schoolYears.join('_') || 'CurrentYear'}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return <DashboardCard title="GPA Distribution" onExport={handleExport}><Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <GPAFilterControls />
        {loading ? <Skeleton variant="rounded" height={400} /> : error ? <Typography color="error" align="center">{error}</Typography> :
        <Box sx={{ flexGrow: 1, minHeight: 0 }}><DevExpressReport dataSource={data} fullPageSize showColumnChooser={false}>
            <Column dataField={pn<GPADistributionDto>('year')} caption="School Year" cellRender={({ value }) => `${value}-${value + 1}`} />
            <Column dataField={pn<GPADistributionDto>('schoolName')} caption="School" />
            <Column dataField={pn<GPADistributionDto>('gradeLevelName')} caption="Grade Level" />
            <Column dataField={pn<GPADistributionDto>('gpaName')} caption="GPA Range" />
            <Column dataField={pn<GPADistributionDto>('studentCount')} caption="Students" />
            <Column dataField={pn<GPADistributionDto>('percentage')} caption="Percentage" cellRender={({ value }) => `${value}%`} />
        </DevExpressReport></Box>}
    </Box></DashboardCard>;
};
